export { default } from './FormSeoConfig.vue'
